export default {
    configuration: false,
    searchList: {
        searchTxt: [
            {
                name: '发车单号',
                value: 'dispatchNo',
                type: 'input',
                unfold: true,
                batch: true,
                fieldTrim: true,
                placeholder: '发车单号(最多查询100单，以逗号隔开)',
                span: 4
            },
            {
                name: '供应商释放订单号',
                value: 'outTradeApplyNo',
                type: 'input',
                unfold: true,
                fieldTrim: true,
                placeholder: '供应商释放订单号',
                span: 4
            },
            {
                name: '资金系统申请单号',
                value: 'gateApplyNo',
                type: 'input',
                unfold: true,
                fieldTrim: true,
                placeholder: '资金系统申请单号',
                span: 4
            },
            {
                name: '结算申请单付款计划号',
                value: 'payPlanNo',
                type: 'input',
                unfold: true,
                fieldTrim: true,
                placeholder: '结算申请单付款计划号',
                span: 4
            },
            {
                name: '释放日期',
                value: 'thawingDate',
                startTime: 'thawingDateStart',
                endTime: 'thawingDateEnd',
                startPlaceholder: '释放开始日期',
                endPlaceholder: '释放结束日期',
                type: 'time',
                unfold: true,
                span: 5
            },
            {
                name: '释放状态',
                value: 'thawingStatus',
                type: 'select',
                optionNum: 'TMS_THAWING_STATUS',
                options: [],
                unfold: true,
                span: 3
            },
            {
                name: '费用类型',
                value: 'feeType',
                type: 'select',
                optionNum: 'TMS_FEE_TYPE',
                options: [],
                unfold: true,
                span: 3
            },
            {
                name: '创建时间',
                value: 'createTime',
                startTime: 'createTimeStart',
                endTime: 'createTimeEnd',
                startPlaceholder: '创建开始日期',
                endPlaceholder: '创建结束日期',
                type: 'time',
                timeNum: 2,
                unfold: true,
                span: 5
            }
        ],
        unfoldState: false,
        advancedBtn: true
    },
    table: {
        height: 400,
        leftWidth: 110,
        tableCut: false,
        clickModify: true,
        selectBtn: true,
        leftOperation: false,
        columns: [
            {
                label: '发车单号',
                prop: 'dispatchNo',
                sort: true,
                fixedColumn: 'left',
                width: 150
            },
            {
                label: '费用类别',
                prop: 'feeType',
                optionNum: 'TMS_FEE_TYPE',
                type: 'select',
                options: [],
                sort: true,
                fixedColumn: 'left',
                width: 150
            },
            {
                label: '分账状态',
                prop: 'divideStatus',
                type: 'select',
                optionNum: 'DIVIDE_STATUS',
                options: [],
                sort: true,
                fixedColumn: 'left',
                width: 140
            }, {
                label: '分账支付对象',
                prop: 'payObject',
                type: 'select',
                optionNum: 'PAY_OBJECT',
                options: [],
                sort: true,
                fixedColumn: 'left',
                width: 160
            },
            {
                label: '分账单支付状态',
                prop: 'payStatus',
                optionNum: 'PAY_STATUS',
                type: 'select',
                options: [],
                sort: true,
                fixedColumn: 'left',
                width: 150
            }, {
                label: '司机收款确认状态',
                prop: 'confirmStatus',
                optionNum: 'DRIVER_EXPENSE_CONFIRM_STATUS',
                type: 'select',
                options: [],
                sort: true,
                fixedColumn: 'left',
                width: 200
            },
            {
                label: '应释放金额',
                prop: 'expectThawingAmount',
                sort: true,
                width: 150
            },
            {
                label: '解冻释放状态',
                prop: 'thawingStatus',
                optionNum: 'TMS_THAWING_STATUS',
                type: 'select',
                options: [],
                sort: true,
                width: 150
            },
            {
                label: '实际释放金额',
                prop: 'actThawingAmount',
                sort: true,
                width: 150
            },
            {
                label: '释放时间',
                prop: 'thawingDate',
                sort: true,
                width: 200
            },
            {
                label: '供应商名称',
                prop: 'carrierName',
                sort: true,
                width: 200
            },
            {
                label: '供应商编码',
                prop: 'carrierCode',
                sort: true,
                width: 200
            },
            {
                label: '司机名称',
                prop: 'driver',
                sort: true,
                width: 150
            },
            {
                label: '司机电话',
                prop: 'driverContactWay',
                sort: true,
                width: 150
            },
            {
                label: '司机编码',
                prop: 'driverNo',
                sort: true,
                width: 150
            },
            {
                label: '未释放原因',
                prop: 'thawingErrorMessage',
                width: 150
            },
            {
                label: '资金释放商户号',
                prop: 'releaseAcctIdentity',
                sort: true,
                width: 240
            },
            {
                label: '供应商释放订单号',
                prop: 'outTradeApplyNo',
                sort: true,
                width: 240
            },
            {
                label: '资金系统申请单号',
                prop: 'gateApplyNo',
                sort: true,
                width: 160
            },
            {
                label: '结算申请单付款计划号',
                prop: 'payPlanNo',
                sort: true,
                width: 200
            },
            {
                label: '结算申请单付款商户号',
                prop: 'bmsPayAccountNo',
                sort: true,
                width: 200
            },
            {
                label: '创建时间',
                width: 150,
                prop: 'createTime',
                sort: true
            }
        ]
    },
    page: {
        layout: 'total, sizes, prev, pager, next',
        pageSize: 10,
        pageSizes: [10, 20, 30, 50]
    },
    searchTotalTitle: [
        {
            name: '司机',
            type: 'advance',
            value: 'driver',
            multiple: true,
            border: true,
            dialogWidth: '800px',
            maxSelect: 5,
            multipleTableColumn: {
                prop: 'name', 'value': '司机名称'
            },
            advanceConfig: [
                { 'prop': 'name', 'value': '司机名称' },
                { 'prop': 'encuMobile', 'value': '司机电话' }
            ],
            tableConfig: [
                { 'prop': 'name', 'value': '司机名称' },
                { 'prop': 'encuMobile', 'value': '司机电话' }
            ],
            advanceUrl: 'suDriver/searchByConditions',
            cbParams: [
                'name#driver', 'encuMobile#driverContactWay'
            ]
        }
    ]
};
